import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=0ad8a39c&scoped=true"
import script from "./EmailForm.vue?vue&type=script&lang=js"
export * from "./EmailForm.vue?vue&type=script&lang=js"
import style0 from "./EmailForm.vue?vue&type=style&index=0&id=0ad8a39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad8a39c",
  null
  
)

export default component.exports